export function normalizeQuestionGroups (groups) {
  if (!Array.isArray(groups)) {
    return []
  }

  return groups.map((group) => ({
    ...group,
    questions: Array.isArray(group.questions)
      ? group.questions.map((question) => ({
          ...question,
          custom: question.source === 'custom' || !!question.custom,
          selected: question.selected != null ? question.selected !== false : question.isEnabled !== false,
        }))
      : [],
  }))
}

export function getPreselectedQuestionIds (groups) {
  return normalizeQuestionGroups(groups).reduce((ids, group) => {
    group.questions.forEach((question) => {
      if (question.selected) {
        ids.push(question.id)
      }
    })
    return ids
  }, [])
}

function getSelectedQuestionCount (selectedQuestionIds) {
  return Array.isArray(selectedQuestionIds) ? selectedQuestionIds.length : 0
}

export function getCreditTotal (selectedQuestionIds, creditPreview) {
  return getSelectedQuestionCount(selectedQuestionIds) * creditPreview.creditsPerQuestion
}

export function getFinalCreditTotal (selectedQuestionIds, creditPreview) {
  return getCreditTotal(selectedQuestionIds, creditPreview) + creditPreview.baseRefreshCredits
}

export function getQuestionsByIds ({ groups, customQuestions, questionIds }) {
  const questions = []
  const idSet = new Set(questionIds || [])
  const questionGroups = groups || []
  const customQuestionList = customQuestions || []

  questionGroups.forEach((group) => {
    const groupQuestions = group.questions || []
    groupQuestions.forEach((question) => {
      if (idSet.has(question.id)) {
        questions.push(question)
      }
    })
  })

  customQuestionList.forEach((question) => {
    if (idSet.has(question.id)) {
      questions.push(question)
    }
  })

  return questions
}

export const CUSTOM_QUESTION_MAX_LENGTH = 200

export const CUSTOM_QUESTION_ERRORS = {
  duplicate: 'That question is already added.',
  maxLength: 'Keep questions under 200 characters.',
}

export function normalizeQuestionText (text) {
  return String(text || '').trim().replace(/\s+/g, ' ').toLowerCase()
}

export function isDuplicateQuestionText (text, existingQuestions, ignoredQuestionId = null) {
  const normalizedText = normalizeQuestionText(text)
  if (!normalizedText) {
    return false
  }

  return (existingQuestions || []).some((question) => (
    question.id !== ignoredQuestionId &&
    normalizeQuestionText(question.text) === normalizedText
  ))
}

export function normalizeCustomQuestion (text, index) {
  return {
    id: `custom-${Date.now()}-${index}`,
    text: text.trim(),
    selected: true,
    custom: true,
  }
}
